import { render, staticRenderFns } from "./shareLink.vue?vue&type=template&id=5b4abe23&scoped=true&"
import script from "./shareLink.vue?vue&type=script&lang=js&"
export * from "./shareLink.vue?vue&type=script&lang=js&"
import style0 from "./shareLink.vue?vue&type=style&index=0&id=5b4abe23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4abe23",
  null
  
)

export default component.exports